import * as angular from "angular";
import { IColumnHeader } from "../../../models/IColumnHeader";
import "./reportColumn.scss";

 interface IComponentBindings {
     column: IColumnHeader;
     highlightText: string;
}

class ReportColumnComponentController implements angular.IComponentController, IComponentBindings {

    column: IColumnHeader;
    highlightText: string;
}

export class ReportColumnComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            column: "<?",
            highlightText:"<"
        };

        this.controller = ReportColumnComponentController;
        this.template = require("./reportColumn.html");
    }
}
